var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgUiCheckCircleLtr = function SvgUiCheckCircleLtr(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 100,
    height: 100
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M69.813 31.885a2.82 2.82 0 0 0-4.01-.03l-29.299 29.07-9.698-9.764-.053-.053a2.82 2.82 0 0 0-3.956.053 2.87 2.87 0 0 0 0 4.036l11.688 11.768.054.053a2.82 2.82 0 0 0 3.94-.038l31.305-31.059.052-.053a2.87 2.87 0 0 0-.023-3.983"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    d: "M49 4C23.319 4 2.5 24.819 2.5 50.5S23.319 97 49 97s46.5-20.819 46.5-46.5S74.681 4 49 4m0 5.635c22.568 0 40.864 18.296 40.864 40.864 0 22.57-18.296 40.865-40.865 40.865-22.568 0-40.864-18.296-40.864-40.865C8.135 27.931 26.431 9.635 49 9.635",
    clipRule: "evenodd"
  })));
};
export default SvgUiCheckCircleLtr;